/**
 * The changed middle of an edit: old and new text minus their common start and
 * end (cut at word boundaries), so markup strikes only the words that change.
 */
export function changedSpan(oldText: string, newText: string) {
  let prefix = 0;
  const max = Math.min(oldText.length, newText.length);
  while (prefix < max && oldText[prefix] === newText[prefix]) prefix++;
  // Back off to a word boundary so a word is never split
  while (prefix > 0 && prefix < max && !/\s/.test(oldText[prefix - 1])) prefix--;

  let suffix = 0;
  const maxSuffix = max - prefix;
  while (
    suffix < maxSuffix &&
    oldText[oldText.length - 1 - suffix] === newText[newText.length - 1 - suffix]
  ) suffix++;
  while (suffix > 0 && suffix < maxSuffix && !/\s/.test(oldText[oldText.length - suffix])) suffix--;

  return {
    start: prefix,
    end: oldText.length - suffix,
    removed: oldText.slice(prefix, oldText.length - suffix),
    added: newText.slice(prefix, newText.length - suffix),
  };
}
